import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

declare var $: any;

@Component({
  selector: "app-rating-feedback",
  templateUrl: "./rating-feedback.component.html",
  styleUrls: ["./rating-feedback.component.scss"],
})
export class RatingFeedbackComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<RatingFeedbackComponent>) {}

  ngOnInit(): void {
    $(".star-input").click((elem: any) => {
      $(elem.target).parent()[0].reset();
      var prevStars = $(elem.target).prevAll();
      var nextStars = $(elem.target).nextAll();
      prevStars.attr("checked", true);
      nextStars.attr("checked", false);
      $(elem.target).attr("checked", true);
      setTimeout(() => {
          this.dialogRef.close(+elem.target.id);
      }, 800);
    });
    $(".star-input-label").on("mouseover", function () {
      var prevStars = $(this).prevAll();
      prevStars.addClass("hovered");
    });
    $(".star-input-label").on("mouseout", function () {
      var prevStars = $(this).prevAll();
      prevStars.removeClass("hovered");
    });
  }
}
